import React, { useEffect, useState } from 'react';
import { Header } from '../../../header/Header';
import MainSider from '../sider/MainSider/MainSider';
import MainContent from '../MainContent/MainContent';
import { MainHeader } from '../MainHeader/MainHeader';
import * as S from './MainLayout.styles';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { References } from '@app/components/common/References/References';

const MainLayout: React.FC = () => {


  const [isTwoColumnsLayout, setIsTwoColumnsLayout] = useState(true);
  const [siderCollapsed, setSiderCollapsed] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const timeout = process.env.REACT_APP_TIMEOUT? process.env.REACT_APP_TIMEOUT: 600000;

  const toggleSider = () => setSiderCollapsed(!siderCollapsed);


  useEffect(() => {
    let timer: NodeJS.Timeout;
  
    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        navigate('/logout?autoLogout=true'); // Redirect to logout
      }, Number(timeout));
    };

    const handleUserActivity = () => resetTimer();

    // Add event listeners for user activity
    window.addEventListener('mousemove', handleUserActivity);
    window.addEventListener('keydown', handleUserActivity);
    window.addEventListener('mousedown', handleUserActivity);

    // Start the initial timer
    resetTimer();

    // Cleanup event listeners and timer on unmount
    return () => {

      clearTimeout(timer);
      window.removeEventListener('mousemove', handleUserActivity);
      window.removeEventListener('keydown', handleUserActivity);
      window.removeEventListener('mousedown', handleUserActivity);
    };
  }, [navigate]);
  const excludedPaths = ['/shortcut/', '/reports/categories'];
  const shouldShowBackButton = !excludedPaths.some((path) => location.pathname.startsWith(path));
  //const sseUrl = URL + '/sse?location=${location}&areaCode
  // =${areaCode}'
  return (
    <S.LayoutMaster>
      <MainSider isCollapsed={siderCollapsed} setCollapsed={setSiderCollapsed} />
      <S.LayoutMain>
        <MainHeader isTwoColumnsLayout={isTwoColumnsLayout}>
          <Header toggleSider={toggleSider} isSiderOpened={!siderCollapsed} isTwoColumnsLayout={isTwoColumnsLayout} />
        </MainHeader>
        <MainContent id="main-content" $isTwoColumnsLayout={isTwoColumnsLayout}>
        {/* {shouldShowBackButton && <GlobalBackButton />} */}
          <div>
            <Outlet />
          </div>
          {!isTwoColumnsLayout && <References />}
        </MainContent>
      </S.LayoutMain>
    </S.LayoutMaster>
  );
};

export default MainLayout;
